import classnames from 'classnames';
import { useEffect, useState } from 'react';

import { Button } from '../../Button/Button';

import styles from './FetchButton.module.scss';
import { BUTTON_STATUS, Props } from './FetchButton.types';

/**
 * @deprecated use the following instead:
 * @example const mutation = useMutation({
 *            mutationFn: async () => {
 *              await new Promise(res => setTimeout(res, 1000));
 *            },
 *          });
 *
 *          <Button onClick={() => mutation.mutate()} mutationStatus={mutation.status}>
 *            <Icon />
 *            text
 *          </Button>
 */
export const FetchButton = ({
  fetchStatus,
  title,
  className,
  secondary,
  onSuccess,
  onError,
  onBeforeErrorAnimation,
  onBeforeSuccessAnimation,
  stayFulfilled,
  ...buttonProps
}: Props) => {
  const [innerStatus, setInnerStatus] = useState<BUTTON_STATUS>(BUTTON_STATUS.PRISTINE);
  useEffect(() => {
    if (fetchStatus === BUTTON_STATUS.PENDING) {
      setInnerStatus(fetchStatus);
    }
    if (innerStatus === BUTTON_STATUS.PENDING && fetchStatus === BUTTON_STATUS.FULFILLED) {
      setInnerStatus(fetchStatus);
      onBeforeSuccessAnimation?.();
      setTimeout(() => {
        onSuccess?.();
        if (!stayFulfilled) {
          setInnerStatus(BUTTON_STATUS.PRISTINE);
        }
      }, 1000);
    }
    if (innerStatus !== BUTTON_STATUS.REJECTED && fetchStatus === BUTTON_STATUS.REJECTED) {
      setInnerStatus(fetchStatus);
      onBeforeErrorAnimation?.();
      setTimeout(() => {
        onError?.();
        setInnerStatus(BUTTON_STATUS.RETRY);
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchStatus, setInnerStatus, onSuccess, onError]);

  return (
    <Button
      variant={secondary ? 'secondary' : 'primary'}
      mutationStatus={
        {
          [BUTTON_STATUS.PRISTINE]: 'idle' as const,
          [BUTTON_STATUS.RETRY]: 'idle' as const,
          [BUTTON_STATUS.PENDING]: 'pending' as const,
          [BUTTON_STATUS.REJECTED]: 'error' as const,
          [BUTTON_STATUS.FULFILLED]: 'success' as const,
        }[innerStatus]
      }
      text={title}
      className={classnames(styles.default, className)}
      {...buttonProps}
    />
  );
};
